import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { ScreenShell, Headline, Subtext } from '../components/ScreenShell';
import { PrimaryButton } from '../components/ui/PrimaryButton';
import { useCopy } from '../contexts/LanguageContext';
interface FinalScreenProps {
  childName: string;
  email: string;
  onFinish: () => void;
}
const STATES = ['done', 'active', 'todo', 'todo', 'todo'] as const;
export function FinalScreen({
  childName,
  email,
  onFinish
}: FinalScreenProps) {
  const copy = useCopy();
  return <ScreenShell data-id="element-59" data-mp="1tbt2m7wab21o">
      <motion.span initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 18
    }} className="inline-flex w-fit items-center gap-2 rounded-full bg-violet-500/10 px-4 py-2 text-sm font-semibold text-violet-700" data-id="element-60" data-mp="1t85drm1sb3ta">
        <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-61" data-mp="19miqt4znt18u" /> {copy.final.badge}
      </motion.span>

      <div className="mt-5" data-id="element-62" data-mp="lh5voytnjdtq">
        <Headline data-id="element-63" data-mp="lfurwz07i62m">{copy.final.headline}</Headline>
        <Subtext data-id="element-64" data-mp="qfqxv3sgs7kt">{copy.final.subtext(childName)}</Subtext>
      </div>

      <ol className="mt-7 rounded-4xl border border-lavender-200 bg-white/90 p-5 shadow-soft" data-id="element-65" data-mp="qdwbrm5gi9f5">
        {copy.final.timeline.map((label, index) => {
        const state = STATES[index] ?? 'todo';
        return <motion.li key={label} initial={{
          opacity: 0,
          x: -8
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.12 * index,
          duration: 0.35
        }} className="flex items-center gap-3 py-2" data-id="element-66" data-mp="107d2uie7laf4" data-mpi={index}>
              <span aria-hidden="true" className={`grid h-6 w-6 shrink-0 place-items-center rounded-full text-[11px] font-bold ${state === 'done' ? 'bg-violet-600 text-white' : state === 'active' ? 'border-2 border-violet-500 bg-violet-500/15 text-violet-600' : 'border border-lavender-200 text-transparent'}`} data-id="element-67" data-mp="ceo7ieufsb43">
                {state === 'done' ? <CheckIcon className="h-3.5 w-3.5" data-id="element-68" data-mp="3jxzri93crgzi" /> : '●'}
              </span>
              <span className={`text-[15px] ${state === 'todo' ? 'text-ink-muted' : 'font-semibold text-ink'}`} data-id="element-69" data-mp="1rd2mnsiubsk">
                {label}
              </span>
            </motion.li>;
      })}
      </ol>

      <p className="mt-6 text-[15px] leading-relaxed text-ink-soft" data-id="element-70" data-mp="318ksek7891xr">
        {copy.final.emailNote}
        {email ? <>
            : <span className="font-semibold text-ink" data-id="element-71" data-mp="3f0hh0e9ostpe">{email}</span>
          </> : '.'}
      </p>
      <p className="mt-1 text-[13px] text-ink-muted" data-id="element-72" data-mp="2mivncdw0kds7">{copy.final.eta}</p>

      <div className="mt-6 whitespace-pre-line rounded-4xl border border-gold-200 bg-gold-200/30 p-5 text-[15px] leading-relaxed text-ink" data-id="element-73" data-mp="2mh2goylehtk7">
        {copy.final.card}
      </div>

      <div className="mt-7" data-id="element-74" data-mp="x0ygfhx2dp3g">
        <PrimaryButton onClick={onFinish} data-id="element-75" data-mp="wzncni3mchcc">{copy.final.cta}</PrimaryButton>
      </div>
    </ScreenShell>;
}